export const INN_LABEL_BLOCK_ID = 'innLabelBlock';
export const OGRN_LABEL_BLOCK_ID = 'ogrnLabelBlock';
export const ORGANIZATION_NAME_BLOCK_ID = 'organizationNameBlock';
export const SNILS_BLOCK_ID = 'snilsBlockId';
export const DOCUMENT_BLOCK_ID = 'documentBlockId';
export const COUNTRY_BLOCK_ID = 'countryBlockId';
export const RAFP_NZA_BLOCK_ID = 'rafpNzaBlockId';
export const KPP_BLOCK_ID = 'kppBlockId';
export const LOCATION_ADDRESS = 'locationAddress';
